module.exports = __webpack_public_path__ + "img/examenes.89af3cc6.png";